import * as React from 'react'
import styled from 'styled-components'
import type { SubscriptionLengthType } from '../../../../flowTypes'
import { SocialButtons } from '../../../shared/buttons'
import { AppleIcon } from '@components/shared/icons/AppleIcon'

export type PropsType = {
  stripe: any,
  plan?: SubscriptionLengthType,
  price: string,
  subscribe: (altPaymentEvent: any) => void,
  trialDays: number
}

type TokenEventType = {
  token: string
}

function ApplePay (props: { onClick: () => void }): React.ReactNode {
  return (
    <SocialButtons
      onClick={(e: any): void => {
        e.preventDefault()
        props.onClick()
      }}
    >
      <IconWrapper>
        <AppleIcon />
      </IconWrapper>
      <ButtonTextSpan>Pay with Apple</ButtonTextSpan>
    </SocialButtons>
  )
}

function GooglePay (props: { onClick: () => void }): React.ReactNode {
  return (
    <SocialButtons
      onClick={(e: any): void => {
        e.preventDefault()
        props.onClick()
      }}
    >
      <img
        width={20}
        height={20}
        style={{ marginRight: '8px' }}
        alt='Pay with Google'
        src={'/images/google-icon-3x.png'}
      />
      Pay with Google
    </SocialButtons>
  )
}

export default function PaymentRequestButton (props: PropsType): React.ReactNode {
  const [paymentRequest, setPaymentRequest] = React.useState<any>(null)
  const [isApplePay, setIsApplePay] = React.useState(false)

  React.useEffect((): void => {
    const plan = props.plan
    if (props.stripe && plan) {
      const priceString = props.price.replace(/[$|.]/g, '')
      const priceInt = parseInt(String(priceString || 69.99))

      const displayItems: any[] = []

      if (!!props.trialDays && props.trialDays > 0) {
        displayItems.push({
          amount: 0,
          label: `${props.trialDays} Day Free Trial`
        })
      }

      let subscriptionLengthText = 'Subscription'
      if (plan === 'annual') {
        subscriptionLengthText = 'Annual subscription'
      } else if (plan === 'monthly') {
        subscriptionLengthText = 'Monthly subscription'
      }

      if (!paymentRequest) {
        const pr = props.stripe.paymentRequest({
          country: 'US',
          currency: 'usd',
          total: {
            label: subscriptionLengthText,
            amount: priceInt
          },
          requestPayerName: true,
          requestPayerEmail: true,
          displayItems
        })
        pr.on('token', async (event: TokenEventType): Promise<void> => {
          props.subscribe(event)
        })
        pr.canMakePayment().then((result: any): void => {
          if (result) {
            if (result.applePay) {
              setIsApplePay(true)
            }
            setPaymentRequest(pr)
          }
        })
      } else {
        paymentRequest.update({
          total: {
            label: subscriptionLengthText,
            amount: priceInt
          }
        })
        setPaymentRequest(paymentRequest)
      }
    }
  }, [props.stripe, props.price, props.plan])

  const handlePayment = (): void => {
    if (paymentRequest) {
      paymentRequest.show()
    }
  }

  if (paymentRequest) {
    return (
      <AltPaymentContainer>
        {isApplePay
          ? (
          <ApplePay onClick={handlePayment} />
            )
          : (
          <GooglePay onClick={handlePayment} />
            )}
      </AltPaymentContainer>
    )
  }
  return <div />
}

const AltPaymentContainer = styled.div<any>`
  width: 100%;
  margin-top: 15px;
`
const ButtonTextSpan = styled.span<any>`
  margin-left: 10px;
`
const IconWrapper = styled.div<any>`
  display: flex;
  margin-bottom: 2px;
`
